import React, { useEffect, useMemo, useState } from 'react'
import { isAndroid, isIOS, isMobile, isSafari } from 'react-device-detect'
import SButton from './SButton'

import { Icon } from '@material-ui/core'
import SFlex from './SFlex'
import { useSTheme } from '../../styles/theme'
import ConditionalRender from '../../utils/conditionalRender'
import SText from './SText'
import { LocalStorageKeys } from '../../utils/localStorage'
import { useTranslation } from '../../i18n'
import moment from 'moment'

const SInstallMobile = () => {
    const theme = useSTheme()
    const { t } = useTranslation(window.LANG_NS)
    const [deferredPrompt, setDeferredPrompt] = useState(null)
    const [closed, setIsClosed] = useState(true)

    const shouldShowInstall = useMemo(() => {
        const seenAlreadyTimestamp = window.localStorage.getItem(LocalStorageKeys.MOBILE_INSTALL_POPUP) || '0'
        const seenDaysAgo = moment().diff(moment(parseInt(seenAlreadyTimestamp, 10)), 'days')
        const seenAlready = seenDaysAgo < 1
        const safariOnIOS = isIOS && isSafari && isMobile
        const android = isAndroid && deferredPrompt && isMobile

        const shouldShow = !seenAlready && (safariOnIOS || android)
        if (shouldShow) {
            window.localStorage.setItem(LocalStorageKeys.MOBILE_INSTALL_POPUP, new Date().getTime().toString())
        }
        return shouldShow
    }, [isIOS, isSafari, isAndroid, deferredPrompt])

    if (!shouldShowInstall) {
        return null
    }

    if (typeof window !== 'undefined' && isAndroid) {
        window.addEventListener('beforeinstallprompt', (e) => {
            try {
                alert('setting')
                // Prevent Chrome 67 and earlier from automatically showing the prompt
                e.preventDefault()
                setDeferredPrompt(e)
            } catch (ignore) {}
        })
    }

    useEffect(() => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/sw.js')
        }
    }, [])

    useEffect(() => {
        if (shouldShowInstall) {
            setTimeout(() => setIsClosed(false), 300)
        }
    }, [shouldShowInstall])

    const onInstallClick = function () {
        deferredPrompt.prompt()
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the A2HS prompt')
            } else {
                console.log('User dismissed the A2HS prompt')
            }
        })
    }

    return (
        <SFlex
            id="install-app"
            justifyContent="center"
            alignItems="center"
            backgroundColor={theme.colors?.white}
            width={'100%'}
            padding={2}
            style={{
                boxSizing: 'border-box',
                position: 'fixed',
                bottom: !shouldShowInstall || closed ? '-200px' : 0,
                transition: 'all 200ms linear',
                display: shouldShowInstall || !closed ? '' : 'none',
                boxShadow: '0 0 25px -5px rgba(0,0,0,1)',
                zIndex: 2147483004, // the chat pop-up is 2147483003 by default, so we need this to be on top of the chat bubble
            }}
        >
            <ConditionalRender if={shouldShowInstall && isAndroid && isMobile && deferredPrompt}>
                <SButton onClick={onInstallClick} display={'flex'} googleIcon={'file_download'}>
                    {t('android_app_install_text')}
                </SButton>
            </ConditionalRender>
            <ConditionalRender if={isIOS && isSafari && isMobile}>
                <SText
                    width={'90%'}
                    padding={0}
                    sx={{
                        justifyContent: 'left',
                        alignItems: 'left',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    fontSize={3}
                >
                    {t('ios_app_install_text_1')}
                    <br />
                    <Icon
                        style={{
                            cursor: 'pointer',
                            color: theme.colors?.secondaryColor,
                            marginRight: '5px',
                        }}
                    >
                        {'ios_share'}
                    </Icon>
                    {t('ios_app_install_text_2')}
                </SText>
            </ConditionalRender>
            <Icon
                onClick={() => setIsClosed(true)}
                style={{
                    cursor: 'pointer',
                    color: theme.colors?.gray200,
                    marginRight: '5px',
                    position: 'absolute',
                    right: '10px',
                }}
            >
                {'close'}
            </Icon>
        </SFlex>
    )
}

SInstallMobile.displayName = 'SInstallMobile'

export default SInstallMobile
